module.exports = __webpack_public_path__ + "static/media/3-2.f77f20b2.mp3";